import axios from "axios";
import { APP_URL } from "../../config/api";
import { errorMessage } from "../errorHandle";

export const addElementToCart = (data) => {
  return (dispatch) => {
    dispatch({
      type: CART.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-cart`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: CART.ADD_ELEMENT_TO_CART,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CART.ERROR));
      });
  };
};

export const showElementToCart = (data) => {
  return (dispatch) => {
    dispatch({
      type: CART.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/show-cart`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: CART.SHOW_ELEMENT_TO_CART,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CART.ERROR));
      });
  };
};

export const removeElementToCart = (data) => {
  return (dispatch) => {
    dispatch({
      type: CART.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/remove-cart`,
        data: data,
      })
      .then((res) => {
        dispatch({
          type: CART.REMOVE_ELEMENT_TO_CART,
          payload: res.data.list,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, CART.ERROR));
      });
  };
};

const TAG = "CART_";

export const CART = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  ADD_ELEMENT_TO_CART: TAG + "ADD_ELEMENT_TO_CART",
  REMOVE_ELEMENT_TO_CART: "REMOVE_ELEMENT_TO_CART",
  SHOW_ELEMENT_TO_CART: TAG + "SHOW_ELEMENT_TO_CART",
};
